import React, { FC } from 'react'
import WechatSimpleItem from './SimpleItem'

interface IProps {
  method?: any;
  selected?: boolean;
  onChange?: () => void;
}

const WechatPayMethodItem: FC<IProps> = ({ method, selected, onChange }) => {
  const amount = method?.amount
  return (
    <WechatSimpleItem selected={selected} amount={amount} onChange={onChange} />
  )
}
export default WechatPayMethodItem
